import { render } from "./KapazitaetplannungView.vue?vue&type=template&id=2b314eb8&scoped=true"
import script from "./KapazitaetplannungView.vue?vue&type=script&lang=js"
export * from "./KapazitaetplannungView.vue?vue&type=script&lang=js"

import "@/styles/kapazitaetplannung.scss?vue&type=style&index=0&id=2b314eb8&scoped=true&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b314eb8"]])

export default __exports__